/* eslint-disable import/prefer-default-export */
// eslint-disable-next-line no-restricted-imports
import { create } from 'axios';
import cookie from 'js-cookie';

export function createAxiosInstance({ config = {} } = {}) {
  const axiosInstance = create({
    baseUrl: '',
    timeout: 8000,
    headers: {
      'Content-Type': 'application/json;charset=utf-8'
    },
    ...config
  });

  // 处理错误码
  const errorHandleInterceptor = axiosInstance.interceptors.response.use(
    (response) => {
      const { data } = response;
      // rpc 开头的业务，数据格式不同，特殊处理
      if (/^\/api\/rpc/.test(response.config.url)) {
        if (data.result === 0) {
          return data;
        }

        if (data.result.error_code === 0) {
          return data;
        }

        return Promise.reject(response);
      }

      const code = data.result.error_code;
      if (code === 0) {
        return data;
      }
      return Promise.reject(response);
    }
  );

  return {
    axiosInstance,
    errorHandleInterceptor
  };
}

export function getCommonRequestData() {
  const sessionStamp = {
    credential: {
      encrypted_unified_ticket: cookie.get('mars_unified_token'), // 统一登录
      encrypted_ticket: cookie.get('mars_access_token')
    }
  };

  return {
    session_stamp: sessionStamp,
    open_id: cookie.get('open_id'),
    encrypted_user_id: cookie.get('encrypted_user_id') // 统一登录
  };
}

export function handleErrorAndAlertMessage(response, errorMessages) {
  // if (!response.data.result) {
  //   return;
  // }
  // const errorCode =
  //   response.data && response.data.result
  //     ? response.data.result.error_code
  //     : '';
  const errorCode = response.data?.result?.error_code || '';
  const message = errorMessages[errorCode] || '服务繁忙，请稍后重试。';
  if (message && weui) {
    weui.alert(message);
  }
}
